module.exports = __webpack_public_path__ + "static/media/spid-idp-posteid~PIAVTNQX.f12f868d.svg";